import { render, staticRenderFns } from "./LoginIdps.vue?vue&type=template&id=4c3c58cd&scoped=true"
import script from "./LoginIdps.vue?vue&type=script&lang=js"
export * from "./LoginIdps.vue?vue&type=script&lang=js"
import style0 from "./LoginIdps.vue?vue&type=style&index=0&id=4c3c58cd&prod&lang=scss&scoped=true"
import style1 from "./LoginIdps.vue?vue&type=style&index=1&id=4c3c58cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3c58cd",
  null
  
)

export default component.exports